import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import FloatingWhatsApp from "./components/FloatingWhatsApp";
import { CatalogProvider } from "./context/CatalogContext";
import Home from "./pages/Home";
import ProductsIndex from "./pages/ProductsIndex";
import ProductDetail from "./pages/ProductDetail";
import About from "./pages/About";
import Contact from "./pages/Contact";

function ScrollAndAnchor() {
    const { pathname, hash } = useLocation();
    useEffect(() => {
        if (hash) {
            const id = hash.replace("#", "");
            const el = document.getElementById(id);
            if (el) {
                setTimeout(() => el.scrollIntoView({ behavior: "smooth", block: "start" }), 60);
                return;
            }
        }
        window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    }, [pathname, hash]);
    return null;
}

function App() {
    return (
        <div className="min-h-screen bg-neutral-bg font-body text-ink antialiased">
            <BrowserRouter>
                <CatalogProvider>
                    <ScrollAndAnchor />
                    <Navbar />
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/products" element={<ProductsIndex />} />
                        <Route path="/products/:slug" element={<ProductDetail />} />
                        <Route path="/about" element={<About />} />
                        <Route path="/contact" element={<Contact />} />
                        <Route path="*" element={<Home />} />
                    </Routes>
                    <Footer />
                    <FloatingWhatsApp />
                </CatalogProvider>
            </BrowserRouter>
        </div>
    );
}

export default App;
